import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ImageLazyWrapper from './LazyImage';
import Button from 'jd-library/Button';
import { useHistory } from 'react-router-dom';
import './order-attachments.scss';
import { getRandomColor } from '../../order/order-return/raise-return-claim/disputeImagesFlow/DisputeImagesUtils';
import ScrollIndicators from '../../../common/ViewImage/ScrollIndicators';
import ImagePreview from './ImagePreview';
import { checkLoggedIn } from '../../../utills';
import UblcsModal from '../../../common/Ublcs-modal';

const OrderAttachments = props => {
	const isReadOnly = useSelector(state => state.session.isReadOnly);
	const parentRef = useRef(null);
    const imagePreviewRef = useRef(null);
    const [previewImageList, updateImageArr] = useState([]);
	const [ublcsModal, toggleUblcsModal] = useState(false)
	const history = useHistory();
	let stylesObj = [];

	const ublcsModalHandler  = () => {
        toggleUblcsModal(true)
    }

    const getFilteredImages = () => {
        return props.list.map((cur, index) => {
            return {
                previewUrl: cur.url,
                fileId: cur.fileId || cur.id,
                key: cur.key || cur.id,
                text: props.list.length == 1 ? '' : <div className="preview-text" style={{
                    "position": `${props.isMobile ? "absolute" : "fixed"}`,
                    "left": "50%",
                    "transform": "translateX(-50%)",
                    "height": "44px",
                    "padding": "10px 20px 10px 20px",
                    "background": "rgba(0,0,0,0.75)",
                    "border-radius": "6px",
                    "display": "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    "font-size": "14px",
                    "top": "20px"
                }}><div>Image&nbsp;</div><div className='prescription-count'>{(index + 1)}</div><span>&nbsp;/&nbsp;</span><div className='prescription-count'>{props.list.length}</div></div>,
                type: cur.extension,
								download: props.from === 'brochure' && cur.extension === 'pdf'
            }
        });
    }
    useEffect(() => {
        updateImageArr(getFilteredImages);
    }, [props.list]);
        
    const onAttachmentClick = (image) => {
        const clickedImageIndex = props.list.findIndex(cur => cur.fileId == image.fileId || cur.fileId == image.id);
        imagePreviewRef.current.onImageClick({clickedImageIndex});
    }


	const imageListHtml = props.list.map((image, index) => {
		if(props.disputeRaised){
			image.extension = image.url.split('.').pop().toLowerCase();
		}
		if (image.tempSave && props.ignoreTemp) {
			return null;
		}
		if (image.tempDel && !props.ignoreTemp) {
			return null;
		}
		if (!stylesObj.index) {
			stylesObj[index] = {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				borderRadius: '4px',
				...getRandomColor(true)
			};
		}
		const imgToRight = props.viewIssue ? (index + 1) % 4 : (index + 1) % 3;
		const rightClass =
			props.viewIssue && !props.isMobile
				? 'view-issues-right-img'
				: props.viewIssue && props.isMobile
				? ''
				: 'right-end-img';
		return (
			<div
				className={`attachment-container brochure_attachment ${
					imgToRight == 0 && !props.disputeRaised ? rightClass : ''
				} ${props.isMobile ? 'attachment-container-mob' : ''} ${
					image.loading ? 'loading-container' : ''
				} ${props.viewIssue ? 'view-issues' : ''} `}
				key={image.key || image.id}
				>
				{image.loading ? (
					<div className={`loader`}>
						<span className={`default-loader`}></span>
					</div>
				) : (
					<Fragment>
						{props.editable  && (
							<span
								className='icon-close-thin attachment-delete'
								onClick={e =>
									props.onCross && props.onCross(e, index)
								}
							/>
						)}
						{!props.editable  && (
							<span
								className='icon-zoomIn attachment-zoom-in'
								onClick={() => onAttachmentClick(image, index)}
							/>
						)}
						<div
							className={`${props.from === 'brochure' ? 'brochure-holder' : 'image-preview-holder'} ${
								props.viewIssue ? 'view-issues-holder' : ''
							}`}
						>
							{image.status ? 
							<div className='image-status'>
								{image.status}
							</div>
							: null}
							<React.Fragment>
								{/* <img src={image.url} /> */}
								<ImageLazyWrapper
									imgAttrs={{
										onClick:() => onAttachmentClick(image, index),
										style:{ cursor: 'pointer' }
									}}
									randomColorObj={stylesObj[index]}
									imageSrc={
										image.extension == 'pdf' || image.ext === 'pdf'
											? 'https://image1.jdomni.in/jdomni_email/pdfGraphic_1904091817.png'
											: image.url
									}
									imgClass='attachment-icon'
								/>
							</React.Fragment>
							{
								(!isReadOnly && !props.isContractor || (props.isContractor && image.approved == 0)) ?
									<span
										className='icon-trash'
										onClick={e =>
											props.onDelete && props.onDelete(e, index, image.id ? image.id : (image.productId || ''))
										}
									/>
									: null
							}
						</div>
						{!props.isMobile && (
							<span class='icon-zoomIn preview-icon'></span>
						)}
					</Fragment>
				)}
			</div>
		);
	});

	const Wrapper = Fragment;

	return (
		<Fragment>
			{props.disputeRaised && !props.isMobile ? <ScrollIndicators
				scrollContainerRef={parentRef}
				mediaLength={props.list.length}
			/>: null}
			<div
				className={`order-attachment-list-zoom ${
					imageListHtml.length === 0 ? 'no-attachments' : ''
				} ${props.className} ${
					props.viewIssue && props.isMobile ? 'horizontal-photo' : ''
				} ${props.disputeRaised ? 'show-slider' : 'grid-view'}`}
				ref={parentRef}
				body-scroll-lock-ignore='true'
			>
				{imageListHtml}
				{console.log(imageListHtml.length, 'ImageList')}
				{!props.disputeRaised && !props.isAuditor ? (
					<>
						{props.editable &&
							imageListHtml.length < props.maxFiles && (
								<Wrapper
									containerRef={parentRef}
									className={'presc-pop'}
								>
									<div
										className={`add-attachment ${
											imageListHtml.length
											 ? props.from === 'brochure' ? 'right-brochure' : 'right-end-img'
												: 'upload-btn-container'
										} ${
											props.isError ? 'upload-error' : ''
										}`}
										onClick={e =>
										{if (isReadOnly) return ublcsModalHandler();
											checkLoggedIn({
												history,
												cb: () => {
												props.isMobile
													? props.onAdd(e, {
															value: e.key
														})
													: props.popClickOptions(e, {
															value: 'gallery'
														})
												}
											})}
										}
									>
										{imageListHtml.length === 0 ? (
											<span>
												<Button
													variant='default'
													className='upload-btn'
												>
													<Fragment>
														<i
															className={`icon-upload upload-icon-styling ${
																props.isMobile
																	? 'upload-icon-styling-mob'
																	: ''
															}`}
														/>{' '}
														<span
															className={
																'marginL5'
															}
														>
															Upload
														</span>
													</Fragment>
												</Button>
											</span>
										) : (
											<div className='add-prescription'>
												{props.customBtn?.icon ? 
													props.customBtn.icon
												: <i
													className={`icon-style icon-cameraNew`}
												></i>}
												<div className='txt'>
													{props.customBtn ? props.customBtn.btnTxt:'Add'}
												</div>
											</div>
										)}
									</div>
								</Wrapper>
							)}
					</>
				) : null}
			</div>
            <ImagePreview
                key="preview"
                isMobile={props.isMobile}
                hashValue={props.isMobile?"imagePreview":""}
                ref={imagePreviewRef}
                imageList={previewImageList}
                keepTextFixed={true}
                textPlacement={'top'}
                showHideCb = {action => bodyScrollHandler(action == 'show')}
            />
			{ublcsModal ? 
				<UblcsModal 
					onHidden= {() => toggleUblcsModal(false)
				}
			/> : null}
		</Fragment>
	);
};

OrderAttachments.defaultProps = {
	maxFiles: 9,
	editable: false,
	list: [],
	className: ''
};

export default OrderAttachments;
